/**
 * Resolve canvas node instance display labels — distinguishes persisted user
 * content from system-default seeded titles (spec: never auto-translate user
 * content; localize system defaults at render time).
 */
import { getNodeDefinition } from './nodeRegistry'

/** True when `fieldLabel` is empty or still the registry-seeded default. */
export function isSystemDefaultInstanceLabel(nodeType: string, fieldLabel: string | undefined): boolean {
  if (!fieldLabel) return true
  const def = getNodeDefinition(nodeType)
  const seeded = def.defaultFields?.label
  if (typeof seeded === 'string' && fieldLabel === seeded) return true
  return fieldLabel === def.label
}

/** User custom title unchanged; system default → localized type label. */
export function resolveNodeInstanceLabel(
  nodeType: string,
  fieldLabel: string | undefined,
  localizedTypeLabel: string,
): string {
  if (isSystemDefaultInstanceLabel(nodeType, fieldLabel)) return localizedTypeLabel
  return fieldLabel!
}
